import {createSlice} from '@reduxjs/toolkit'
import { FETCH_BUSINESS_LICENCE_PDF, SEND_MESSAGE_URL } from '../../app/constants'

const bltDecisionSlice = createSlice({
    name : "bltDecision",
    initialState : {},
    reducers : {

    }
})

export const sendEmail = (emailContent) => async (dispatch, getState) => {

    const {csrfToken} = getState().userAuth

    const {toEmail, subject, body, cc, fromEmail} = emailContent

    let payloadData = {
        toEmail, 
        subject, 
        body,
        cc,
        fromEmail
    }

    let headers = new Headers()
    headers.append('Content-Type',"application/json")
    headers.append("X-CSRF-TOKEN", csrfToken)

    return fetch(SEND_MESSAGE_URL,{
                method : "POST",
                headers: headers,
                body : JSON.stringify(payloadData)
            })
            .then(resp => resp.json())
            .then(data => data)
            .catch(err => err)

}

export default bltDecisionSlice.reducer


export const fetchBusinessLicnecePDF = async (applicationId) => {
    const response = await fetch(`${FETCH_BUSINESS_LICENCE_PDF}/${applicationId}`)
    const data = await response.json();

    return data
}
